import * as _ from "lodash";

import { BaseDto } from "./base.dto";
import { FileDto } from "./file.dto";
import { PagingDto } from "./paging.dto";
import { TranslationDto } from "./translation.dto";

class MallDto {
  id?: string;
  name?: TranslationDto;
  slug?: string;
}

// mapping to form
export class EventMappingDto extends BaseDto {
  bannerImage?: FileDto;
  title?: TranslationDto;
  startDate?: string;
  endDate?: string;
  content?: TranslationDto;
  customerLimit?: number;
  checkInCode?: string;
  displayStatus?: boolean;
  mallIds?: string[];

  static create({
    id,
    bannerImage,
    title,
    startDate,
    endDate,
    content,
    customerLimit,
    checkInCode,
    mallIds,
    displayStatus,
  }: EventMappingDto) {
    return _.assign<EventDto>({
      id: id || null,
      bannerImage: bannerImage || null,
      title: title || TranslationDto.create(),
      startDate: startDate || null,
      endDate: endDate || null,
      content: content || TranslationDto.create(),
      customerLimit: customerLimit || null,
      checkInCode: checkInCode || null,
      displayStatus: displayStatus || true,
      mallIds: mallIds || null,
    });
  }
}

// event response
export class EventDto extends BaseDto {
  mall?: MallDto[];
  bannerImage?: FileDto;
  title?: TranslationDto;
  startDate?: string;
  endDate?: string;
  content?: TranslationDto;
  customerLimit?: number;
  checkInCode?: string;
  displayStatus?: boolean;
  customerRegister?: number;
  customerCheckedIn?: number;
  deepLink?: string;
}

export class CustomerMallDto {
  id?: string;
  name?: TranslationDto;
}

export class CustomerDto extends BaseDto {
  fullName?: string;
  email?: string;
  phoneNumber?: string;
  eventTitle: TranslationDto;
  eventMallName: CustomerMallDto[];
  id: string;
}

export class FindEventDto extends PagingDto {
  searchKey?: string;
  displayStatus?: boolean;
  activityStatus?: number;
  mallId?: string;
  mallIds?: string;
}

export class FindCustomerEventDto extends PagingDto {
  type?: string;
}

export class CreateEventDto {
  mallIds: string[];
  bannerImageId: string;
  title: TranslationDto;
  startDate: string;
  endDate: string;
  content: TranslationDto;
  customerLimit?: number;
  displayStatus: boolean;
  checkInCode: string;
}

export class UpdateEventDto extends CreateEventDto {
  id: string;
}
